import { render, staticRenderFns } from "./create-court.vue?vue&type=template&id=ee73ce90&scoped=true&"
import script from "./create-court.vue?vue&type=script&lang=ts&"
export * from "./create-court.vue?vue&type=script&lang=ts&"
import style0 from "./create-court.vue?vue&type=style&index=0&id=ee73ce90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee73ce90",
  null
  
)

component.options.__file = "create-court.vue"
export default component.exports